import script from "./BaseLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseLoader.vue?vue&type=script&setup=true&lang=js"

import "./BaseLoader.vue?vue&type=style&index=0&id=a8a6e1c6&lang=scss"

const __exports__ = script;

export default __exports__